module.exports = __webpack_public_path__ + "img/03-04-img-1.1c9752d7.png";